import React, { useEffect, useState } from "react";
import axios from "axios";
import { getToken } from "../../utils/tokenUtils";

const HolidaysList = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = getToken();

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axios.get(
          "https://hrmsnew.prepstripe.com/api/public-holidays",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setHolidays(response.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHolidays();
  }, [token]);

  if (loading) return <p>Loading holidays...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h2>Public Holidays</h2>
      <ul>
        {holidays.map((holiday) => (
          <li key={holiday.id}>
            {holiday.date} - {holiday.occasion}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HolidaysList;
